<template>
  <div class="privatepolicy">
    <p v-html="data"></p>
  </div>
</template>

<script>
export default {
  name: "clapprivatepolicy",
  data() {
    return {
      data:
        '<html xmlns:v="urn:schemas-microsoft-com:vml"\n' +
        'xmlns:o="urn:schemas-microsoft-com:office:office"\n' +
        'xmlns:w="urn:schemas-microsoft-com:office:word"\n' +
        'xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"\n' +
        'xmlns="http://www.w3.org/TR/REC-html40">\n' +
        "\n" +
        "<head>\n" +
        '<meta http-equiv=Content-Type content="text/html; charset=gb2312">\n' +
        "<meta name=ProgId content=Word.Document>\n" +
        '<meta name=Generator content="Microsoft Word 12">\n' +
        '<meta name=Originator content="Microsoft Word 12">\n' +
        '<link rel=File-List href="隐私协议.files/filelist.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <o:DocumentProperties>\n" +
        "  <o:Author>Lyz</o:Author>\n" +
        "  <o:LastAuthor>W10</o:LastAuthor>\n" +
        "  <o:Revision>2</o:Revision>\n" +
        "  <o:TotalTime>10</o:TotalTime>\n" +
        "  <o:Created>2021-04-28T01:39:00Z</o:Created>\n" +
        "  <o:LastSaved>2021-04-28T01:39:00Z</o:LastSaved>\n" +
        "  <o:Pages>3</o:Pages>\n" +
        "  <o:Words>456</o:Words>\n" +
        "  <o:Characters>2605</o:Characters>\n" +
        "  <o:Lines>21</o:Lines>\n" +
        "  <o:Paragraphs>6</o:Paragraphs>\n" +
        "  <o:CharactersWithSpaces>3055</o:CharactersWithSpaces>\n" +
        "  <o:Version>12.00</o:Version>\n" +
        " </o:DocumentProperties>\n" +
        " <o:OfficeDocumentSettings>\n" +
        "  <o:AllowPNG/>\n" +
        " </o:OfficeDocumentSettings>\n" +
        "</xml><![endif]-->\n" +
        '<link rel=themeData href="隐私协议.files/themedata.thmx">\n' +
        '<link rel=colorSchemeMapping href="隐私协议.files/colorschememapping.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <w:WordDocument>\n" +
        "  <w:TrackMoves>false</w:TrackMoves>\n" +
        "  <w:TrackFormatting/>\n" +
        "  <w:PunctuationKerning/>\n" +
        "  <w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing>\n" +
        "  <w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery>\n" +
        "  <w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery>\n" +
        "  <w:ValidateAgainstSchemas/>\n" +
        "  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>\n" +
        "  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>\n" +
        "  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>\n" +
        "  <w:DoNotPromoteQF/>\n" +
        "  <w:LidThemeOther>EN-US</w:LidThemeOther>\n" +
        "  <w:LidThemeAsian>ZH-CN</w:LidThemeAsian>\n" +
        "  <w:LidThemeComplexScript>X-NONE</w:LidThemeComplexScript>\n" +
        "  <w:Compatibility>\n" +
        "   <w:SpaceForUL/>\n" +
        "   <w:BalanceSingleByteDoubleByteWidth/>\n" +
        "   <w:DoNotLeaveBackslashAlone/>\n" +
        "   <w:ULTrailSpace/>\n" +
        "   <w:DoNotExpandShiftReturn/>\n" +
        "   <w:AdjustLineHeightInTable/>\n" +
        "   <w:BreakWrappedTables/>\n" +
        "   <w:SnapToGridInCell/>\n" +
        "   <w:WrapTextWithPunct/>\n" +
        "   <w:UseAsianBreakRules/>\n" +
        "   <w:DontGrowAutofit/>\n" +
        "   <w:SplitPgBreakAndParaMark/>\n" +
        "   <w:DontVertAlignCellWithSp/>\n" +
        "   <w:DontBreakConstrainedForcedTables/>\n" +
        "   <w:DontVertAlignInTxbx/>\n" +
        "   <w:Word11KerningPairs/>\n" +
        "   <w:CachedColBalance/>\n" +
        "   <w:UseFELayout/>\n" +
        "  </w:Compatibility>\n" +
        "  <m:mathPr>\n" +
        '   <m:mathFont m:val="Cambria Math"/>\n' +
        '   <m:brkBin m:val="before"/>\n' +
        '   <m:brkBinSub m:val="--"/>\n' +
        "   <m:smallFrac/>\n" +
        "   <m:dispDef/>\n" +
        '   <m:lMargin m:val="0"/>\n' +
        '   <m:rMargin m:val="0"/>\n' +
        '   <m:defJc m:val="centerGroup"/>\n' +
        '   <m:wrapIndent m:val="1440"/>\n' +
        '   <m:intLim m:val="subSup"/>\n' +
        '   <m:naryLim m:val="undOvr"/>\n' +
        "  </m:mathPr></w:WordDocument>\n" +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="true"\n' +
        '  DefSemiHidden="true" DefQFormat="false" DefPriority="99"\n' +
        '  LatentStyleCount="267">\n' +
        '  <w:LsdException Locked="false" Priority="0" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Normal"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="heading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="35" QFormat="true" Name="caption"/>\n' +
        '  <w:LsdException Locked="false" Priority="10" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" Name="Default Paragraph Font"/>\n' +
        '  <w:LsdException Locked="false" Priority="11" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtitle"/>\n' +
        '  <w:LsdException Locked="false" Priority="22" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Strong"/>\n' +
        '  <w:LsdException Locked="false" Priority="20" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Table Grid"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Placeholder Text"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="No Spacing"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Revision"/>\n' +
        '  <w:LsdException Locked="false" Priority="34" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="List Paragraph"/>\n' +
        '  <w:LsdException Locked="false" Priority="29" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="30" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="19" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="21" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="31" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="32" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="33" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Book Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="37" Name="Bibliography"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" QFormat="true" Name="TOC Heading"/>\n' +
        " </w:LatentStyles>\n" +
        "</xml><![endif]-->\n" +
        "<style>\n" +
        "<!--\n" +
        " /* Font Definitions */\n" +
        " @font-face\n" +
        "\t{font-family:宋体;\n" +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-alt:SimSun;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"Cambria Math";\n' +
        "\tpanose-1:2 4 5 3 5 4 6 3 2 4;\n" +
        "\tmso-font-charset:1;\n" +
        "\tmso-generic-font-family:roman;\n" +
        "\tmso-font-format:other;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:0 0 0 0 0 0;}\n" +
        "@font-face\n" +
        "\t{font-family:Calibri;\n" +
        "\tpanose-1:2 15 5 2 2 2 4 3 2 4;\n" +
        "\tmso-font-charset:0;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-469750017 -1073732485 9 0 511 0;}\n" +
        "@font-face\n" +
        "\t{font-family:Tahoma;\n" +
        "\tpanose-1:2 11 6 4 3 5 4 4 2 4;\n" +
        "\tmso-font-charset:0;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-520081665 -1073717157 41 0 66047 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@宋体";\n' +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        " /* Style Definitions */\n" +
        " p.MsoNormal, li.MsoNormal, div.MsoNormal\n" +
        "\t{mso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:justify;\n" +
        "\ttext-justify:inter-ideograph;\n" +
        "\tmso-pagination:none;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "h1\n" +
        "\t{mso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-link:"标题 1 Char";\n' +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tmso-outline-level:1;\n" +
        "\tfont-size:24.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h2\n" +
        "\t{mso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-link:"标题 2 Char";\n' +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tmso-outline-level:2;\n" +
        "\tfont-size:18.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h3\n" +
        "\t{mso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-link:"标题 3 Char";\n' +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tmso-outline-level:3;\n" +
        "\tfont-size:13.5pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h4\n" +
        "\t{mso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-link:"标题 4 Char";\n' +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tmso-outline-level:4;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h5\n" +
        "\t{mso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-link:"标题 5 Char";\n' +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tmso-outline-level:5;\n" +
        "\tfont-size:10.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "p.MsoHeader, li.MsoHeader, div.MsoHeader\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页眉 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:center;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tborder:none;\n" +
        "\tmso-border-bottom-alt:solid windowtext .75pt;\n" +
        "\tpadding:0cm;\n" +
        "\tmso-padding-alt:0cm 0cm 1.0pt 0cm;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p.MsoFooter, li.MsoFooter, div.MsoFooter\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页脚 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p\n" +
        "\t{mso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;}\n" +
        "span.1Char\n" +
        '\t{mso-style-name:"标题 1 Char";\n' +
        "\tmso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        '\tmso-style-link:"标题 1";\n' +
        "\tmso-ansi-font-size:24.0pt;\n" +
        "\tmso-bidi-font-size:24.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-ascii-font-family:宋体;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-hansi-font-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tmso-font-kerning:18.0pt;\n" +
        "\tfont-weight:bold;}\n" +
        "span.2Char\n" +
        '\t{mso-style-name:"标题 2 Char";\n' +
        "\tmso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        '\tmso-style-link:"标题 2";\n' +
        "\tmso-ansi-font-size:18.0pt;\n" +
        "\tmso-bidi-font-size:18.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-ascii-font-family:宋体;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-hansi-font-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tmso-font-kerning:0pt;\n" +
        "\tfont-weight:bold;}\n" +
        "span.3Char\n" +
        '\t{mso-style-name:"标题 3 Char";\n' +
        "\tmso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        '\tmso-style-link:"标题 3";\n' +
        "\tmso-ansi-font-size:13.5pt;\n" +
        "\tmso-bidi-font-size:13.5pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-ascii-font-family:宋体;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-hansi-font-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tmso-font-kerning:0pt;\n" +
        "\tfont-weight:bold;}\n" +
        "span.4Char\n" +
        '\t{mso-style-name:"标题 4 Char";\n' +
        "\tmso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        '\tmso-style-link:"标题 4";\n' +
        "\tmso-ansi-font-size:12.0pt;\n" +
        "\tmso-bidi-font-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-ascii-font-family:宋体;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-hansi-font-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tmso-font-kerning:0pt;\n" +
        "\tfont-weight:bold;}\n" +
        "span.5Char\n" +
        '\t{mso-style-name:"标题 5 Char";\n' +
        "\tmso-style-priority:9;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        '\tmso-style-link:"标题 5";\n' +
        "\tmso-ansi-font-size:10.0pt;\n" +
        "\tmso-bidi-font-size:10.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-ascii-font-family:宋体;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-hansi-font-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;\n" +
        "\tmso-font-kerning:0pt;\n" +
        "\tfont-weight:bold;}\n" +
        "span.Char\n" +
        '\t{mso-style-name:"页眉 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页眉;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        "span.Char0\n" +
        '\t{mso-style-name:"页脚 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页脚;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        ".MsoChpDefault\n" +
        "\t{mso-style-type:export-only;\n" +
        "\tmso-default-props:yes;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;}\n" +
        " /* Page Definitions */\n" +
        " @page\n" +
        "\t{mso-page-border-surround-header:no;\n" +
        "\tmso-page-border-surround-footer:no;\n" +
        '\tmso-footnote-separator:url("隐私协议.files/header.htm") fs;\n' +
        '\tmso-footnote-continuation-separator:url("隐私协议.files/header.htm") fcs;\n' +
        '\tmso-endnote-separator:url("隐私协议.files/header.htm") es;\n' +
        '\tmso-endnote-continuation-separator:url("隐私协议.files/header.htm") ecs;}\n' +
        "@page Section1\n" +
        "\t{size:595.3pt 841.9pt;\n" +
        "\tmargin:72.0pt 90.0pt 72.0pt 90.0pt;\n" +
        "\tmso-header-margin:42.55pt;\n" +
        "\tmso-footer-margin:49.6pt;\n" +
        "\tmso-paper-source:0;\n" +
        "\tlayout-grid:15.6pt;}\n" +
        "div.Section1\n" +
        "\t{page:Section1;}\n" +
        " /* List Definitions */\n" +
        " @list l0\n" +
        "\t{mso-list-id:38021522;\n" +
        "\tmso-list-template-ids:307138518;}\n" +
        "@list l1\n" +
        "\t{mso-list-id:2046251929;\n" +
        "\tmso-list-template-ids:-1815938524;}\n" +
        "ol\n" +
        "\t{margin-bottom:0cm;}\n" +
        "ul\n" +
        "\t{margin-bottom:0cm;}\n" +
        "-->\n" +
        "</style>\n" +
        "<!--[if gte mso 10]>\n" +
        "<style>\n" +
        " /* Style Definitions */\n" +
        " table.MsoNormalTable\n" +
        "\t{mso-style-name:普通表格;\n" +
        "\tmso-tstyle-rowband-size:0;\n" +
        "\tmso-tstyle-colband-size:0;\n" +
        "\tmso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmso-padding-alt:0cm 5.4pt 0cm 5.4pt;\n" +
        "\tmso-para-margin:0cm;\n" +
        "\tmso-para-margin-bottom:.0001pt;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "</style>\n" +
        "<![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapedefaults v:ext="edit" spidmax="5122"/>\n' +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapelayout v:ext="edit">\n' +
        '  <o:idmap v:ext="edit" data="1"/>\n' +
        " </o:shapelayout></xml><![endif]-->\n" +
        "</head>\n" +
        "\n" +
        "<body lang=ZH-CN style='tab-interval:21.0pt;text-justify-trim:punctuation'>\n" +
        "\n" +
        "<div class=Section1 style='layout-grid:15.6pt'>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:2'><b><span style='mso-bidi-font-size:10.5pt;font-family:\n" +
        "宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;mso-bidi-font-family:\n" +
        "Tahoma;color:#333333;mso-font-kerning:0pt'>亲爱的用户，您好：</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        'mso-font-kerning:0pt\'>试卷拍拍是由北京云圈科技有限公司（下称云圈）基于<a name="_GoBack">教育</a>信息资源开发的应用产品。云圈非常重视您的个人信息或个人数据信息。在您仔细阅读、了解并同意本政策之前，不要向云圈提交任何个人信息、数据等隐私信息（下称</span><span\n' +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>“</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>信息</span><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>”</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>）。如果您是未成年人，应当与父母或监护人共同审阅本协议，以确保您及您的父母或监护人了解本协议。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:2'><b><span style='mso-bidi-font-size:10.5pt;font-family:\n" +
        "宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;mso-bidi-font-family:\n" +
        "Tahoma;color:#333333;mso-font-kerning:0pt'>通过本隐私政策，云圈希望您了解以下内容：</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何收集及使用您的信息</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>2.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何披露您的信息</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>3.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>如何更新、变更或检查您的信息</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>4.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何保护您的信息</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>5.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何处理未成年人提供的信息</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>6.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>第三方服务提供商</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>7.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>信息传输</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>8.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>本政策的更新</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan'><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>9.</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>与云圈联络</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>请注意，本政策是云圈针对信息处理和保护的主要策略，但本政策可能无法解决您的信息处理和保护的所有问题，因此云圈会针对某些特定服务提供特定隐私政策作为本政策的补充，以便在基于特定目的处理和保护您的信息时通知客户，请您在使用云圈产品或服务时，注意其他形式的此类通知。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>1.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何收集及使用您的信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:4'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.1&nbsp;</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈收集及使用信息的方式、时机与目的</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:5'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.1.1</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>个人注册信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>当您注册云圈账号时，我们会根据您的选择收集您的手机号，以及微信、</span><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>QQ</span><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>、微博等第三方登录平台的登录授权信息，以帮助完成账号相关权益的保存以及跨平台共享。您还可以根据自身需求上传头像、昵称等信息，主要为您提供更多个性化的产品服务。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>请您妥善保管您的账号、密码，如您将密码告知他人、与他人共享注册账户或其他个人保管不善事由导致的任何个人信息泄露、丢失、被盗用或被篡改等，云圈不对此承担责任。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:5'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.1.2</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>获取设备权限</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>1.1.2.1</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>网络权限：主要用于播放音视频及列表页面访问。当在使用手机流量播放音视频时，需获得您的确认后才会使用。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>1.1.2.2</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>相机权限：主要用于根据个人需要的个性化头像上传。</span><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>1.1.2.3</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>语音权限：用于应用中的语音互动功能的使用。</span><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>1.1.2.4</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>位置权限：用于提供基于位置的互动服务的使用。</span><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:5'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.1.3</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>收集设备信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈会收集某些信息进行统计与分析，这类信息包括您的设备名称</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>、设备的粗略地理位置信息 </span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'> (</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>例如设备所在的网络位置编码</span><span lang=EN-US style='mso-bidi-font-size:\n" +
        '10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>)</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>、运营商网络ID(PLMN)、</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>ID(PLMN)</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>应用使用情况、您访问互联网的IP地址、</span><span lang=EN-US style='mso-bidi-font-size:\n" +
        '10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>IP</span><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>设备存储。云圈收集并处理这类信息的唯一目的是：提供您最佳的人性化用户体验、提供个性化内容、改善我们的产品、分析我们的运营效率、统计市场占有率、改善网络和服务的安全性，以及启用您的售后保障服务。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:5'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.1.4</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>收集播放记录信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈可能会收集您的视频播放记录，使您能够查看您的浏览历史。我们还会收集您在订阅、收藏功能中添加的信息，使您能够更加轻松快捷地访问您感兴趣的内容。您的观看历史、订阅、收藏信息会存储在我们的服务器中，以便您通过多终端登录时使用上述功能，您也可以随时在任意客户端删除这些信息。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:4'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>1.2&nbsp;</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>去标识化信息的收集及使用</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>「去标识化信息」是指无法识别特定个人身份的信息，例如我们应用的启动次数、页面的点击次数。云圈会收集这类信息，以了解用户如何使用我们的应用、产品或服务，如此云圈才能进行改善，以满足客户的需求。云圈可以自行决定是否基于任何其他目的，收集、使用、移转或披露非个人信息。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>2.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何披露您的信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>只有符合下列情况时，云圈才会披露您的信息。在下列情形之外，云圈绝不会将您的信息披露给第三方</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:4'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>(1)</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>您已明确同意：在得到您的批准后，云圈才会将您的信息透露给其他公司；</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:4'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>(2)</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>将您的信息披露给云圈关联公司或授权合作的第三方：</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈可能需要通过某些合作方为您提供某些服务，因此云圈需要将您的部分信息共享给合作方，以便丰富我们的服务以及满足您的需求，例如，当您决定在线购买云圈产品时，云圈将需要将您的信息上传到云圈后台，方便您跨平台享有购买的权益；</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:4'><b><span lang=EN-US style='mso-bidi-font-size:10.5pt;\n" +
        'font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'>(3)</span></b><b><span style='mso-bidi-font-size:10.5pt;\n" +
        "font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>依法律要求，披露您的信息：</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>依法律、法院等司法机关命令或其他法律程序的规定，或相关政府机关的要求，云圈可能会提供您的信息。在云圈涉及重组、合并或清算的情况下，您的信息可能也会提供给交易方。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>3.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>如何更新、变更或检查您的信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>您应该对所提交的信息的准确性负责，云圈将尽到商业上合理的努力，确保您信息的准确性。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>4.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何保护您的信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈采取合理的预防措施，包括但不限于物理上、技术及制度等方面，以保护您的信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。例如，在技术方面，云圈使用防病毒软件、加密保护、监控我们的系统，以及增强我们数据中心的攻击防护；物理方面，云圈设定门禁措施及访问控制，仅允许需要这类信息的业务人员浏览；在制度方面，则通过对云圈员工进行安全与隐私保护知识培训，确保员工了解保护数据的重要性。虽然我们采用合理的措施来保护您的个人数据，但没有任何安全措施能够百分之百完美或牢不可破。但由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而导致您的信息泄露、丢失、被盗用或被篡改的，云圈无需承担责任，但应采取补救措施，按照规定及时告知您并向有关主管部门报告。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>5.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>云圈如何处理未成年人的信息</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈鼓励父母或监护人指导未成年人使用云圈的产品或服务。如果法律有相关规定，云圈不会在未征得监护人同意的前提下收集未成年人的信息。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为保护未成年人而使用或披露有关未成年人的信息。「未成年人」的定义应考虑适用的法律，以及各国家和地区的文化惯例。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用使用云圈的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过第</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>10</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>条中的联系方式与我们联系。</span><span lang=EN-US style='mso-bidi-font-size:\n" +
        '10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>6.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>第三方服务提供商</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>为方便您的访问并丰富您的体验，可能会有非云圈的第三方提供内容或因特网链接。您可以选择是否访问这类链接或内容，是否使用这类第三方的服务或产品，但云圈对于这些并没有控制权。云圈无法控制第三方的任何隐私权和数据保护措施，这类措施不受本政策管理，本政策也不适用于您自行选择提供给第三方的任何信息，<u>请您在使用这类第三方的服务或产品时查看第三方的隐私保护政策</u>。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>7.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>信息传输</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈产品与服务可能会由位于世界不同国家或地区的资源与服务器提供。因此，您的信息可能会跨国界而传输到您使用我们服务所在国家或地区之外的国家和地区，那些国家或地区可能没有对信息提供具体保护的法律，或是实行不同的数据保护法。在这类情况下，云圈将采取措施，确保有法律基础可进行这类传输，以及依适用法律，会对您信息提供适当的保护，例如，通过使用相关授权单位核准的标准合约（必要时），以及通过使用其他适当的技术与信息安全措施。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>8.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>本隐私政策的更新</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈可能会不定期修订本《隐私政策》的条款，云圈将在修订生效前通过云圈儿歌的显著位置提示，或尽可能通过可行的渠道和方法，将修订通知您，请您更新最新版本的云圈产品查询修订后的《隐私政策》。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>&nbsp;</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>在该种情况下，<u>若您继续使用云圈的产品或服务，即表示同意受修订后的《隐私政策》的约束</u>。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>9.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>其他</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>本隐私政策是云圈统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于云圈用户。</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left;\n" +
        "mso-pagination:widow-orphan;mso-outline-level:3'><b><span lang=EN-US\n" +
        'style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:\n' +
        "宋体;color:#333333;mso-font-kerning:0pt'>10.</span></b><b><span style='mso-bidi-font-size:\n" +
        "10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;\n" +
        "mso-bidi-font-family:Tahoma;color:#333333;mso-font-kerning:0pt'>与云圈联络</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>如果您有任何问题、意见或建议，以及要求删除后台的用户数据，您可以发邮件到</span><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:0pt'>fumeiling@yunquancn.com</span><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>与我们联络。</span><span lang=EN-US style='mso-bidi-font-size:\n" +
        '10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left;mso-pagination:widow-orphan'><span\n" +
        "style='mso-bidi-font-size:10.5pt;font-family:宋体;mso-ascii-font-family:Tahoma;\n" +
        "mso-hansi-font-family:Tahoma;mso-bidi-font-family:Tahoma;color:#333333;\n" +
        "mso-font-kerning:0pt'>云圈保留本政策条款之解释权。</span><span lang=EN-US style='mso-bidi-font-size:\n" +
        '10.5pt;font-family:"Tahoma","sans-serif";mso-fareast-font-family:宋体;color:#333333;\n' +
        "mso-font-kerning:0pt'><o:p></o:p></span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=right style='text-align:right;mso-pagination:widow-orphan;\n" +
        "mso-outline-level:1'><b><span style='mso-bidi-font-size:10.5pt;font-family:\n" +
        "宋体;mso-ascii-font-family:Tahoma;mso-hansi-font-family:Tahoma;mso-bidi-font-family:\n" +
        "Tahoma;color:#333333;mso-font-kerning:18.0pt'>北京云圈科技有限公司</span></b><b><span\n" +
        'lang=EN-US style=\'mso-bidi-font-size:10.5pt;font-family:"Tahoma","sans-serif";\n' +
        "mso-fareast-font-family:宋体;color:#333333;mso-font-kerning:18.0pt'><o:p></o:p></span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal><span lang=EN-US><o:p>&nbsp;</o:p></span></p>\n" +
        "\n" +
        "</div>\n" +
        "\n" +
        "</body>\n" +
        "\n" +
        "</html>\n"
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 26px;
}
ol {
  float: left;
  margin-left: 20px;
  padding: 10px;
}
li {
  flex: 1;
  margin-top: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
p {
  color: #000;
  size: 26px;
  text-align: left;
  width: 100%;
  letter-spacing: 4px;
  line-height: 200%;
}
.hello {
  width: 100%;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ClapPrivacyPolicy.vue